import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';

@Component({
  selector: 'fdk-dialog-content',
  templateUrl: './dialog-content.component.html',
  styleUrl: './dialog-content.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkDialogContentComponent {}
